import { render, staticRenderFns } from "./CreateEdit.vue?vue&type=template&id=2753b70a&scoped=true&"
import script from "./CreateEdit.vue?vue&type=script&lang=js&"
export * from "./CreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./CreateEdit.vue?vue&type=style&index=0&id=2753b70a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2753b70a",
  null
  
)

export default component.exports